module.exports = __webpack_public_path__ + "1370a9d9b33e2e733555e80acb2b454b.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/background_jyogui-logo.png
// module id = 121
// module chunks = 0